var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ClientB2c2bCard',{attrs:{"client":_vm.client,"commercials":_vm.commercials}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }